// @ts-check
import { Bar, BarChart, Tooltip, XAxis, YAxis } from 'recharts';
import BlockCard from '../BlockCard';
import { formatRupees } from '../../../utils/wholesale';

/** Spend by category for the range (categories come from the API), with the change on the previous equal period (an em dash when there was none). */
export default function ExpensesBlock({ block }) {
  const { total = 0, delta_pct: delta = null, by_category: categories = [] } = block.data || {};
  const rounded = delta === null || delta === undefined ? null : Math.round(delta);
  const bars = categories.map((c) => ({ name: c.category.replace(/_/g, ' '), amount: c.amount }));

  return (
    <BlockCard title="Expenses" href={block.href} headline={block.headline && { ...block.headline, display: formatRupees(block.headline.value) }}>
      {total > 0 ? (
        <div data-testid="expenses-chart" className="overflow-x-auto">
          <BarChart width={320} height={130} data={bars} aria-hidden="true">
            <XAxis dataKey="name" tickLine={false} axisLine={false} fontSize={10} interval={0} />
            <YAxis hide allowDecimals={false} />
            <Tooltip formatter={(v) => [formatRupees(v), 'Spend']} />
            <Bar dataKey="amount" fill="#8b5cf6" isAnimationActive={false} />
          </BarChart>
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">No expenses in this range</p>
      )}
      <p className="mt-2 text-sm text-muted-foreground" data-testid="expenses-delta">
        {rounded === null ? '—' : `${rounded > 0 ? '+' : ''}${rounded}%`} vs previous period
      </p>
    </BlockCard>
  );
}
